module.exports = __webpack_public_path__ + "img/map3.e1db8dff.jpg";